import { Routes } from '@router/routes';

export const TESTIMONIALS_DATA = [
  {
    id: 1,
    path: '/images/testimonial-person-1.webp',
    alt: 'Sargis Grigor photo',
    title: 'Sargis Grigor',
    subtitle: 'CEO by PixelPerfect',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
  {
    id: 2,
    path: '/images/testimonial-person-2.webp',
    alt: 'Bagrat Leo photo',
    title: 'Bagrat Leo',
    subtitle: 'CEO by NOX',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
  {
    id: 3,
    path: '/images/testimonial-person-3.webp',
    alt: 'Gor Sargis photo',
    title: 'Gor Sargis',
    subtitle: 'Data analyst',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
  {
    id: 4,
    path: '/images/testimonial-person-4.webp',
    alt: 'Maral Mari photo',
    title: 'Maral Mari',
    subtitle: 'Data analyst',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
  {
    id: 5,
    path: '/images/testimonial-person-5.webp',
    alt: 'Hakob Jirair photo',
    title: 'Hakob Jirair',
    subtitle: 'Data engineer',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
  {
    id: 6,
    path: '/images/testimonial-person-6.webp',
    alt: 'Eva Vosgi photo',
    title: 'Eva Vosgi',
    subtitle: 'Data scientist',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
  {
    id: 7,
    path: '/images/testimonial-person-7.webp',
    alt: 'Kohar Marine photo',
    title: 'Kohar Marine',
    subtitle: 'Data scientist',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
  {
    id: 8,
    path: '/images/testimonial-person-8.webp',
    alt: 'Ararat Ohannes photo',
    title: 'Ararat Ohannes',
    subtitle: 'Data analyst',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
  {
    id: 9,
    path: '/images/testimonial-person-9.webp',
    alt: 'Eduard Vosgi photo',
    title: 'Eduard Vosgi',
    subtitle: 'Data scientist',
    text: '“Ut enim ad minima veniam, quis nostrum exercitationem ullam corpor suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis utem vel eum iure reprehender qui in ea voluptate velit esse quam nihil molesti consequatur, vel illum.”',
  },
];

export const BLOG_DATA = [
  {
    id: 1,
    path: '/images/blog-news-1.webp',
    alt: 'ISO 13485 compliance of medical devices photo',
    title: 'ISO 13485 compliance of medical devices',
    subtitle: '22 June 2022',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure...',
  },
  {
    id: 2,
    path: '/images/blog-news-2.webp',
    alt: 'Business analysis helps you  in finance photo',
    title: 'Business analysis helps you  in finance',
    subtitle: '23 June 2022',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure...',
  },
  {
    id: 3,
    path: '/images/blog-news-3.webp',
    alt: '5 web portal examples your business can learn from photo',
    title: '5 web portal examples your business can learn from',
    subtitle: '24 June 2022',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure...',
  },
  // TODO поменять повт. данные ниже, когда будет страница Blog
  {
    id: 4,
    path: '/images/blog-news-1.webp',
    alt: 'ISO 13485 compliance of medical devices photo',
    title: 'ISO 13485 compliance of medical devices',
    subtitle: '22 June 2022',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure...',
  },
  {
    id: 5,
    path: '/images/blog-news-2.webp',
    alt: 'Business analysis helps you  in finance photo',
    title: 'Business analysis helps you  in finance',
    subtitle: '23 June 2022',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure...',
  },
  {
    id: 6,
    path: '/images/blog-news-3.webp',
    alt: '5 web portal examples your business can learn from photo',
    title: '5 web portal examples your business can learn from',
    subtitle: '24 June 2022',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure...',
  },
];

export const PRICING_DATA = [
  {
    id: 1,
    title: 'Free trial',
    price: '$00',
    durations: ['Mo', 'Yr'],
    possibilities: ['For small teams – 5 users', 'Community support'],
  },
  {
    id: 2,
    title: 'Lite',
    price: '$99',
    durations: ['Mo', 'Yr'],
    possibilities: ['For small teams – 15 users', 'Individual support', 'Individual data – 60GB'],
  },
  {
    id: 3,
    title: 'Basic',
    price: '$199',
    durations: ['Mo', 'Yr'],
    possibilities: [
      'For big teams – 30 users',
      'Individual support',
      'Individual data – 120GB',
      'Advanced permissions',
    ],
  },
  {
    id: 4,
    title: 'For enterprises',
    price: 'Custom',
    durations: ['Mo', 'Yr'],
    possibilities: [
      'Unlimited team members',
      'Individual support',
      'Unlimited Individual data',
      'Advanced permissions',
      'Data history',
      'Audit log',
      'All functions included',
    ],
  },
];

export const SOLUTIONS_DATA = [
  {
    id: 1,
    path: '/images/solutions-database.svg',
    alt: 'Data integration icon',
    title: 'Data integration',
    text: 'Extract, transform, load (ETL) or extract, load, transform (ELT); data governance (security, availability, quality) implementation.',
    link: Routes.SOLUTIONS,
  },
  {
    id: 2,
    path: '/images/solutions-calendar.svg',
    alt: 'Data integration icon',
    title: 'Data integration',
    text: 'Data preparation and management; machine learning (ML); designing and implanting artificial intelligence (AI) solutions.',
    link: Routes.SOLUTIONS,
  },
  {
    id: 3,
    path: '/images/solutions-clipboard.svg',
    alt: 'Big data icon',
    title: 'Big data',
    text: 'Big data infrastructure setup and support.; big data quality and security management; big data capture, analysis and reporting.',
    link: Routes.SOLUTIONS,
  },
  {
    id: 4,
    path: '/images/solutions-data.svg',
    alt: 'Data warehousing icon',
    title: 'Data warehousing',
    text: 'The process of constructing and using a data warehouse. Data warehouse and data marts design and implementation.',
    link: Routes.SOLUTIONS,
  },
  {
    id: 5,
    path: '/images/solutions-whisker.svg',
    alt: 'Self-service BI icon',
    title: 'Self-service BI',
    text: 'Business intelligence; data analytics infrastructure design and implementation; scheduled analytics querying and reporting.',
    link: Routes.SOLUTIONS,
  },
  {
    id: 6,
    path: '/images/solutions-pie.svg',
    alt: 'Data visualization icon',
    title: 'Data visualization',
    text: 'Interactive dashboarding; custom and pre-built visuals; multiple visualization techniques (symbol maps, line charts, pie charts...)',
    link: Routes.SOLUTIONS,
  },
];

export const FAQ_ACCORDION_DATA = [
  {
    label: 'What are data analytics?',
    content:
      'Phasellus tristique eu nisl eu consectetur. Morbi urna massa, imperdiet in mauris et, euismod vestibulum lacus. Integer enim elit, tincidunt aliquam ligula id, lacinia auctor orci. Sed quis lobortis eros.',
  },
  {
    label: 'What is data mining?',
    content:
      'Icons are everywhere. These "little miracle workers" (as John Hicks described them) help us reinforce meaning in the interfaces we design and build. Their popularity in web design has never been greater; the conciseness and versatility of pictograms in particular make them a lovely fit for displays large and small. But icons on the web have had their fair share of challenges.',
  },
  {
    label: 'What is business intelligence?',
    content:
      'Most assistive devices will read aloud text inserted via CSS, and many of the Unicode characters icon fonts depend on are no exception. Best-case scenario, your "favorite" icon gets read aloud as "black favorite star." Worse-case scenario, it`s read as "unpronounceable" or skipped entirely.',
  },
  {
    label: 'What is exploratory data analysis (EDA)?',
    content:
      'When your icon font fails, the browser treats it like any other font and replaces it with a fallback. Best-case scenario, you`ve chosen your fallback characters carefully and something weird-looking but communicative still loads. Worse-case scenario (and far more often), the user sees something completely incongruous, usually the dreaded "missing character" glyph.',
  },
  {
    label: 'What is confirmatory data analysis (CDA)?',
    content:
      'Phasellus tristique eu nisl eu consectetur. Morbi urna massa, imperdiet in mauris et, euismod vestibulum lacus. Integer enim elit, tincidunt aliquam ligula id, lacinia auctor orci. Sed quis lobortis eros.',
  },
  {
    label: 'What are predictive analytics?',
    content:
      'Many dyslexic people find it helpful to swap out a website`s typeface for something like OpenDyslexic. But icon fonts get replaced as well, which makes for a frustratingly broken experience.',
  },
  {
    label: 'What is data visualisation',
    content:
      'SVG is awesome for icons! It`s a vector image format with optional support for CSS, JavaScript, reusability, accessibility and a bunch more. It was made for this sort of thing.',
  },
];

export const SERVICES_DATA = [
  {
    id: 1,
    path: '/images/services-brain.svg',
    alt: 'Machine learning icon',
    title: 'Machine learning',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure.',
    link: Routes.SERVICES,
  },
  {
    id: 2,
    path: '/images/services-lines.svg',
    alt: 'Embed analytics icon',
    title: 'Embed analytics',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure.',
    link: Routes.SERVICES,
  },
  {
    id: 3,
    path: '/images/services-key.svg',
    alt: 'Access control icon',
    title: 'Access control',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure.',
    link: Routes.SERVICES,
  },
  {
    id: 4,
    path: '/images/services-area.svg',
    alt: 'Data analytics icon',
    title: 'Data analytics',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure.',
    link: Routes.SERVICES,
  },
  {
    id: 5,
    path: '/images/services-pie.svg',
    alt: 'Big data consulting icon',
    title: 'Big data consulting',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure.',
    link: Routes.SERVICES,
  },
  {
    id: 6,
    path: '/images/services-bot.svg',
    alt: 'Artificial intelligence icon',
    title: 'Artificial intelligence',
    text: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas. Quis autem vel eum iure.',
    link: Routes.SERVICES,
  },
];
